<template>
  <component :is="component" :filterData="filterData" v-if="component"/>
</template>

<script>
export default {
  name: "BoardFilterLink",
  mixins: [],
  components: {},
  props: {
    filterLayout: {},
    filterData: {
      default: () => {
      },
    },
  },
  data() {
    return {
      component: null
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/board/filter/BoardFilterDefaultLayout');
        })
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.filterLayout) {
        return null;
      }
      return () => import(`@/template/board/filter/${this.filterLayout}`);
    }
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>